import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../contexts/I18nContext";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-[var(--js-border)] mt-16" style={{ background: "#F1EADD" }} data-testid="site-footer">
      <div className="container-narrow px-6 py-12 grid gap-8 md:grid-cols-4">
        <div>
          <div className="font-heading text-2xl text-[var(--js-primary)]">{t("org")}</div>
          <p className="text-sm text-[var(--js-muted)] mt-2 font-devanagari">जयतु संस्कृतम्</p>
          <p className="text-sm text-[var(--js-muted)] mt-3">{t("tagline")}</p>
        </div>
        <div>
          <div className="font-semibold mb-3">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[var(--js-primary)]">{t("nav.about")}</Link></li>
            <li><Link to="/districts" className="hover:text-[var(--js-primary)]">{t("nav.districts")}</Link></li>
            <li><Link to="/courses" className="hover:text-[var(--js-primary)]">{t("nav.courses")}</Link></li>
            <li><Link to="/programmes" className="hover:text-[var(--js-primary)]">{t("nav.programmes")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold mb-3">Participate</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/volunteers" className="hover:text-[var(--js-primary)]">{t("nav.volunteers")}</Link></li>
            <li><Link to="/donate" className="hover:text-[var(--js-primary)]">{t("nav.donate")}</Link></li>
            <li><Link to="/contact" className="hover:text-[var(--js-primary)]">{t("nav.contact")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold mb-3">Connect</div>
          <p className="text-sm text-[var(--js-muted)]">Follow us for Sanskrit programmes across Odisha.</p>
          <p className="text-xs text-[var(--js-muted)] mt-4">© {new Date().getFullYear()} Jayatu Sanskrutam. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
